// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_exgLY {
  /* min-width: calc((100% - 30px)/4) !important; */
  width: 100%;
}

.cardAreaGood_onHbu {
  background-color: #029E2E !important;
}

.cardAreaGood_onHbu * {
  color: white !important;
}

.cardAreaBad_z9D1d {
  background-color: #DB253D !important;
}

.cardAreaBad_z9D1d * {
  color: white !important;
}

.detailBox_pWHqI * {
  color: #394756 !important;
}

.factoryPaceCardDetailContentGood_InfD9 {
  color: #029E2E !important;
}

.factoryPaceCardDetailContentBad_oXoa4 {
  color: #DB253D !important;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/factoryCycleTimeMonitoring/components/mobile/PaceOverviewCards.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".card {\n  /* min-width: calc((100% - 30px)/4) !important; */\n  width: 100%;\n}\n\n.cardAreaGood {\n  background-color: #029E2E !important;\n}\n\n.cardAreaGood * {\n  color: white !important;\n}\n\n.cardAreaBad {\n  background-color: #DB253D !important;\n}\n\n.cardAreaBad * {\n  color: white !important;\n}\n\n.detailBox * {\n  color: #394756 !important;\n}\n\n.factoryPaceCardDetailContentGood {\n  color: #029E2E !important;\n}\n\n.factoryPaceCardDetailContentBad {\n  color: #DB253D !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card_exgLY`,
	"cardAreaGood": `cardAreaGood_onHbu`,
	"cardAreaBad": `cardAreaBad_z9D1d`,
	"detailBox": `detailBox_pWHqI`,
	"factoryPaceCardDetailContentGood": `factoryPaceCardDetailContentGood_InfD9`,
	"factoryPaceCardDetailContentBad": `factoryPaceCardDetailContentBad_oXoa4`
};
export default ___CSS_LOADER_EXPORT___;
